import { Typography } from 'seagull';
import { routes } from "../../../constants";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import ExternalLinkButton from "../../../components/ExternalLinkButton";
import { useEventReporter, useOverlayContext, useStoreActions } from "../../../contexts";
import MakeLogo from "./MakeLogo";
import CopyAPIKeyModal from "../CopyAPIKeyModal/CopyAPIKeyModal";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function MakeCard() {
  const {
    api
  } = useStoreActions();
  const {
    reportToAppcues,
    reportToGtm,
    reportToHeap,
    reportToHubspot
  } = useEventReporter();
  const {
    MANAGE_API_KEYS
  } = useFeatureFlags();
  const overlayContext = useOverlayContext();
  const {
    logBI
  } = useStoreActions();
  const openIntegrateModal = () => {
    logBI(12050);
    reportToAppcues('button-click', "make-vendor-clicked-connect");
    reportToGtm('button-click', "make-vendor-clicked-connect");
    reportToHeap('integrations', 'click', "make-connect");
    reportToHubspot("vendor_clicked_connect_to_make");
    const steps = MANAGE_API_KEYS ? [/*#__PURE__*/_jsxs(Typography, {
      children: ["1. Go to the", ' ', /*#__PURE__*/_jsx(ExternalLinkButton, {
        href: routes.anchorApiKeys,
        underline: "none",
        openInNewTab: true,
        children: "Anchor API Keys"
      }), ' ', "page and generate a new API key for Make."]
    }), '2. Log in to your Make account and create a scenario with Anchor', '3. Paste the API key when setting up the connection'] : ['1. Copy the API key below', '2. Log in to your Make account and create a scenario with Anchor', '3. Paste the API key when setting up the connection'];
    overlayContext.showModal({
      closeOnEscapeKey: true,
      closeOnClickOutside: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(CopyAPIKeyModal, {
          dismissModal: dismissModal,
          title: "Make",
          integrationUrl: "https://www.make.com/en/apps",
          testId: "make",
          steps: steps,
          getApiKey: () => api.make.getApiKey(),
          onCopyApiKey: () => {
            logBI(12051);
            reportToAppcues('button-click', "make-vendor-copied-api-key-to-clipboard");
            reportToGtm('button-click', "make-vendor-copied-api-key-to-clipboard");
            reportToHeap('integrations', 'click', "make-copy-api-key");
            reportToHubspot('vendor_copied_api_key_to_clipboard');
          }
        });
      }
    });
  };
  return /*#__PURE__*/_jsx(IntegrationCard, {
    "data-testid": "make-card",
    icon: /*#__PURE__*/_jsx(MakeLogo, {}),
    title: "Make",
    subTitle: "Connect Anchor to any app or API to automate your workflows",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      onClick: openIntegrateModal,
      "data-testid": "make-card-connect",
      children: "Connect"
    })
  });
}